<template>
  <div>
    <div class="common__main-contener mb-3">
      <div class="d-flex align-items-center mb-3">
        <h5 class="font-weight-bold mb-0">
          <span class="mr-3">{{formatDate}}</span>
          <span class="mr-3">Lessons</span>
        </h5>
        <DateInputWithIcon v-model="date" @changeDate="changeDate"/>
      </div>

      <table v-if="lessons.length > 0" class="ml-3">
        <tr
          v-for="lesson of lessons"
          :key="lesson.id"
        >
          <td>
            <router-link
              v-if="lesson.type !== 'waiting'"
              :to="{
                name: 'ClassRecordEdit',
                params: {lessonId: lesson.id},
              }"
              class="mr-2"
            >
              {{lesson.courseName}}
            </router-link>
            <div v-else>
              -----
            </div>
          </td>
          <td>
            <div class="mr-2">[{{lesson.type}}]</div>
          </td>
          <td>
            <div class="mr-2">Period {{lesson.period}}</div>
          </td>
          <td>
            <div class="mr-2">{{lesson | Unit}}</div>
          </td>
          <td>
            <div class="mr-2">{{lesson | lessonName}}</div>
          </td>
          <td>
            <div class="d-flex">
              <div
                v-for="student of lesson.students"
                :key="student.studentName"
                class="mr-1"
              >
                {{student.studentName}}
              </div>
            </div>
          </td>
        </tr>
      </table>
      <div v-else>
        <h6>There are no lessons on this day</h6>
      </div>
    </div>
    <div class="common__main-contener">
      <div class="d-flex align-items-center mb-3">
        <h5 class="font-weight-bold mb-0">
          <span class="mr-3">{{formatDate}}</span>
          <span class="mr-3">Events</span>
        </h5>
      </div>
      <div v-if="events.length">
        <div
          class="information__description pl-3"
          v-for="event of events"
          :key="event.id"
        >
          <span class="mr-2">{{event | eventTime}}</span>
          <span>{{event.type}}</span>
        </div>
      </div>
      <div v-else>
        <h6>There are no events on this day</h6>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import moment from 'moment';
import DateInputWithIcon from '@/components/parts/inputItem/DateInputWithIcon.vue';
import { Component, Vue } from 'vue-property-decorator'
import { Lesson, Event } from '@/store/mypage/types';

@Component({
  components: {
    DateInputWithIcon,
  },
  filters: {
    Unit(lesson: Lesson) {
      if (lesson.type === 'waiting') {
        return '-----'
      }
      return `Unit ${lesson.unit}`
    },

    lessonName(lesson: Lesson) {
      if (lesson.type === 'waiting') {
        return '-----'
      }
      const campus = lesson.campusName
      const building = lesson.boothBuilding || ''
      const room = lesson.boothRoom || ''
      const number = lesson.boothNumber || ''
      return `(${campus} ${building}-${room}-${number})`
    },

    eventTime(event: Event) {
      if (event.type === 'absent' || event.type === 'workOnHoliday') {
        return 'all times'
      }
      const startTime = moment(event.startTime, 'HHmm').format('HH:mm')
      const endTime = moment(event.endTime, 'HHmm').format('HH:mm')

      return `${startTime} ~ ${endTime}`
    },
  },
})

export default class LessonComponent extends Vue {
  date: string = ''

  private created() {
    this.date = moment().format('YYYYMMDD');
    this.$store.dispatch('fetchMypageLessons', this.date);
    this.$store.dispatch('fetchEvents', this.date);
  }

  private get lessons() {
    return this.$store.state.mypage.lessons;
  }

  private get events() {
    return this.$store.state.mypage.events;
  }

  private get formatDate() {
    return moment(this.date, 'YYYYMMDD').format('YYYY/MM/DD(ddd)');
  }

  private changeDate() {
    this.$store.dispatch('fetchMypageLessons', this.date);
    this.$store.dispatch('fetchEvents', this.date);
  }
}
</script>

<style scoped>
.date {
  margin-right:5px;
}

.information__description:not(:last-child) {
  margin-bottom: 10px;
}

.lesson-date {
  background: none;
}

.datepickerContent {
  position: relative;
}

.icon {
  position: absolute;
  top:0;
  width: 25px;
  height: 25px;
  margin:auto 0;
  cursor:pointer;
  pointer-events: none;
}

</style>

<style>
  .calender_button {
    border:none;
    display:block;
    background:none;
    cursor:pointer;
    width: 25px;
    height: 25px;
    opacity: 0;
  }
</style>
